import React from 'react';
import { Section, preloader } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';

import balloonSlide from '../../baseSlides/balloonSlide';
import headingSlide from '../../baseSlides/headingSlide';

import imagePPALogo from '../../images/logo_ppa.png';
import esGooberGoofySmile from '../../images/characters/esmeralda_goober_goofy_smile.png';
import ianSaraSilly from '../../images/characters/ian_sara_silly.png';
import esGooberProud from '../../images/characters/esmeralda_goober_proud.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile_en from './ending.md';
import markdownFile_fr_CA from './ending.fr_CA.md';

const md = i18nData({
  en: new MarkdownScript(markdownFile_en),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});

export function preloadEnding() {
  preloader([
    esGooberGoofySmile,
    ianSaraSilly,
    esGooberProud,
    imagePPALogo
  ]);
}

function endingSection({ regionData, i18n }) {
  const md_i18n = i18n(md);
  return (
    <Section id="ending">

      {/* Time to see who won! */}
      {balloonSlide({
        id: 'announce-winners',
        characterSide: 'right',
        characterImage: ianSaraSilly,
        html: md_i18n.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
        notes: md_i18n.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
      })}

      {/* You're now all Planet Protectors */}
      {balloonSlide({
        id: 'planet-protectors',
        characterSide: 'left',
        characterImage: esGooberProud,
        html: md_i18n.getSubSectionAsHtml('Planet Protectors', 'Content', false, regionData),
        notes: md_i18n.getSubSectionAsHtml('Planet Protectors', 'Notes', false, regionData)
      })}

      {/* You've completed all the levels */}
      {headingSlide({
        id: 'completed',
        beforeImage: imagePPALogo,
        heading: i18n('H2Whoa') + '!',
        subHeading: i18n('All levels completed') + '!!!',
        notes: md_i18n.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
        bgColor: 'black'
      })}

    </Section>
  );
}

export default endingSection;



// WEBPACK FOOTER //
// ./programs/h2whoa/sections/95_ending/endingSection.jsx